import { HttpClient } from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable, forkJoin } from "rxjs";

type ImageData = {
    url: string,
    file: File
}

export class BaseUploadImage<T> {
    protected _http: HttpClient = inject(HttpClient)

    protected uploadImage(req: ImageData){
        const formData = new FormData()
        formData.append('file', req.file)

        return this._http.post<T>(req.url, formData)
    }

    protected uploadImages(req: ImageData[]){
        const obs: Observable<T>[] = []

        req.forEach(request => {
            obs.push(this.uploadImage(request))
        })

        return forkJoin(obs)
    }

    protected getImage(url: string){
        return this._http.get(url, {responseType: 'blob'})
    }

    protected getImages(urls: string[]){
        const obs: Observable<Blob>[] = []

        urls.forEach(url => {
            obs.push(this.getImage(url))
        })

        return forkJoin(obs)
    }
}   